<template>
    <div
        class="sl-contact-hidden-banner"
        :class="{ 'sl-contact-hidden-banner--no-quota': noQuota }"
        t_label="EMPBE_Sale_Lead_unlockToView"
    >
        <svg
            class="sl-contact-hidden-banner__icon"
            width="16"
            height="16"
            viewBox="0 0 14 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M11.6667 5.83333H10.8333V4.16667C10.8333 1.86667 8.96667 0 6.66667 0C4.36667 0 2.5 1.86667 2.5 4.16667V5.83333H1.66667C0.75 5.83333 0 6.58333 0 7.5V15.8333C0 16.75 0.75 17.5 1.66667 17.5H11.6667C12.5833 17.5 13.3333 16.75 13.3333 15.8333V7.5C13.3333 6.58333 12.5833 5.83333 11.6667 5.83333ZM6.66667 13.3333C5.75 13.3333 5 12.5833 5 11.6667C5 10.75 5.75 10 6.66667 10C7.58333 10 8.33333 10.75 8.33333 11.6667C8.33333 12.5833 7.58333 13.3333 6.66667 13.3333ZM9.25 5.83333H4.08333V4.16667C4.08333 2.74167 5.24167 1.58333 6.66667 1.58333C8.09167 1.58333 9.25 2.74167 9.25 4.16667V5.83333Z"
                fill="currentColor"
            />
        </svg>
        <span class="sl-contact-hidden-banner__text">{{ $t('lbl_EMPBE_SalesLead_ContactHiddenBanner') }}</span>
    </div>
</template>
<script>
export default {
    name: 'unlockToView',
    props: {
        /** true = 额度已用尽：紫橙渐变；false = 仍有额度：与顶部解锁横幅同色浅蓝 */
        noQuota: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
.sl-contact-hidden-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    border-radius: 4px;
    background: #E7F8FF;
    border: 1px solid #B8DDF0;
}

.sl-contact-hidden-banner__icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    display: block;
    /* 设计阈值 */
    color: rgba(82, 154, 255, 1);
}

.sl-contact-hidden-banner__text {
    flex: 1 1 auto;
    min-width: 0;
    color: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    font-weight: 600;
    line-height: 150%;
}

.sl-contact-hidden-banner--no-quota {
    border: none;
    background: radial-gradient(
        ellipse 241.8% 251.52% at 102.83% 124.79%,
        #FFD631 0%,
        #FF7931 14%,
        #9554E2 45%,
        #8550FF 75%,
        #6231FF 100%
    );

    .sl-contact-hidden-banner__icon {
        color: #fff;
    }

    .sl-contact-hidden-banner__text {
        color: #fff;
    }
}
</style>
